export default {
    data () {
        return {
            disclaimer_agree: false,
            show_vr_disclaimer: false,
            vr_link: ''
        }
    },
    methods: {
        openVr (url) {
            console.log('open vr',url)
            this.vr_link = url
            if (this.show_disclaimer) {
                this.toggleVrTip()
            } else {
                this.confirmDisclaimer()
            }
        },
        toggleVrTip () {
            this.show_vr_disclaimer = !this.show_vr_disclaimer
            if (!this.show_vr_disclaimer) {
                this.resetDisclaimerTip()
            }
        },
        resetDisclaimerTip () {
            this.disclaimer_agree = false
        },
        toggleDisclaimerAgree () {
            this.disclaimer_agree = !this.disclaimer_agree
        },
        confirmDisclaimer () {
            console.log('open vr',this.vr_link)
            this.$router.push({
                path: this.vr_link
            })
        }
    }
}